import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TClipTranscription, TPatchClipTranscription } from '../types';

import { clipsQueryKeys } from './query-keys';

type TPatchClipTranscriptionBody = {
  id: string;
  body: TPatchClipTranscription;
};
export async function patchClipTranscription({
  id,
  body,
}: TPatchClipTranscriptionBody): Promise<TClipTranscription> {
  return mediaManagerClient.patch(`/api/v1/clip_transcriptions/${id}`, emptyStringValues(body));
}

type MutationFn = typeof patchClipTranscription;

type TUsePatchClipTranscriptionParams = {
  config?: MutationConfig<MutationFn>;
  invalidateClipQueries?: boolean;
};

export function usePatchClipTranscription({
  config = {},
  invalidateClipQueries = false,
}: TUsePatchClipTranscriptionParams = {}) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchClipTranscription,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar la transcripción del corte'));
      console.error(error);
    },
    onSuccess() {
      if (invalidateClipQueries) {
        queryClient.invalidateQueries({
          queryKey: clipsQueryKeys.all,
        });
      }
      addSuccessNotification(t('La transcripción del corte se ha actualizado correctamente'));
    },
  });
}
